// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  api: {
    //baseurl: "http://localhost:5000",
    baseurl: "https://liveapi.savedesk.co",
    //baseurl: "http://124.123.66.250:8081",

    login: "/open/token",
    getRegisterDetails: "/open/user/add",
    registerUser: "/open/user/save",
    verifyActivationToken: "/open/activation",
    verifyResetToken: "/open/forgetPassword",
    forgotPassword: "/open/forgetPassword",
    changePassword: "/admin/user/changePassword",
    adminUserList: "/admin/user/list",
    saveUser: "/admin/user/save",
    addUserType: "/admin/user/add",
    getUser: "/admin/user/get",
    updateUserActive: "/admin/user/updateActive",
    getAuthPersonForClient: "/client/auth/get",
    saveAuthPersonForClient: "/client/auth/save",
    addFile: "/upload/add",
    getFile: "/upload/getById",
    getAllBank: "/client/bank/all",
    getBankDetailsRequiredData: "/client/bank/add",
    saveBankForClient: "/client/bank/save",
    getOtherDetails: "/client/other/get",
    getBank: "/client/bank/get",
    saveOtherDetailsForClient: "/client/other/save",
    getCurrencyRequired: "/client/currency/add",
    editCurrencyRequired: "/client/currency/edit",
    getCurrencyDetails: "/client/currency/get",
    saveCurrencyDetails: "/client/currency/save",
    getCurrencyPreferenceRequired: "/client/currencyPrefer/add",
    getCurrencyPreference: "/client/currencyPrefer/get",
    saveCurrencyPreference: "/client/currencyPrefer/save",
    deleteCurrencyPreference: "/client/currencyPrefer/delete",
    deleteCurrencyDetail: "/client/currency/delete",
    getRegularUpdatesRequiredData: "/regularUpdate/add",
    getRegularUpdates: "/regularUpdate/list",
    saveRegularUpdate: "/regularUpdate/save",
    updateRegularUpdate: "/regularUpdate/edit",
    updateRegularUpdateStatus: "/regularUpdate/updateActive",
    updateRegularUpdateold: "/regularUpdate/updateHold",
    updateNewsActive: "/newsUpdate/updateActive",
    createOrder: "/pay/createOrder",
    confirmPayment: "/pay/response",
    editRegularUpdate: "/regularUpdate/edit",
    getAllPlans: "/admin/plan/getPlans",
    getCurrentPlan: "/admin/plan/currentPlan",
    selectPlan: "/admin/plan/selectPlan",
    getNewsUpdate: "/newsUpdate/list",
    fetchNewUpdateRequiredData: "/newsUpdate/add",
    editNewsUpdate: "/newsUpdate/edit",
    saveNewsUpdate: "/newsUpdate/save",
    fetchUserInfo: "/main/userInfo",
    requiredEvent: "/event/add/",
    allEvents: "/event/list",
    saveEvent: "/event/save",
    updateEventStatus: "/event/updateActive",
    eventEdit: "/event/edit",
    currencyHoliday: "/event/uploadCurrencyHolyDay",
    commonHoliday: "/event/uploadHolyDay",
    fetchPremiumDetails: "/admin/premiumRate/get",
    updatePremiumDetails: "/admin/premiumRate/save",
    getCalculatorData: "/admin/deal/addDeal",
    addDeal: "/admin/deal/saveDeal",
    getTransactions: "/admin/deal/list",
    getSDTransactions: "/admin/deal/Sdlist",
    getTransaction: "/admin/deal/getDeal",
    getSubUserList: "/admin/user/clientUserList",
    getClientProfile: "/admin/user/getProfile",
    gatdashboardData: "/dashboard/addDeal",
    getPreferredCurrency: "/dashboard/prefCur",
    getCount: "/dashboard/getCount",
    refreshFavPair: "/dashboard/prefCurRefresh",
    getDeal: "/dashboard/getRates",
    getCalendarData: "/dashboard/getCalendarData",
    getEventData: "/dashboard/getEventData",

    getTopNews: "/dashboard/topNews",
    updateDealCompleted: "/admin/deal/dealCompleted/:dealId",
    updateAdminDealCompleted: "/admin/deal/sdCompleted/:dealId",
    updateAdminDealConnect: "/admin/deal/sdConnect/:dealId",
    updateDealCover: "/admin/deal/dealCover/:dealId",
    getExpertAdvice: "/admin/deal/getExpertAdvice/:dealId",
    holdDeal: "/admin/deal/holdDeal/:dealId",
    resumeDeal: "/admin/deal/resumeDeal/:dealId",
    rateAlert: "/client/currencyNotify/add",
    saveFxRateAlert: "/client/currencyNotify/save",
    deleteDeal: "/admin/deal/delete/:dealId",
    deleteAll: "/admin/deal/deleteAll?dealIds=:dealIds",

    saveBulkDealList:"/admin/bulkDeal/saveDeal",
    saveBulkDealBookingList:"/admin/bulkDeal/saveDealBooking",
    bulkDealListCurrency:"/admin/bulkDeal/addDeal",
    bulkDealListById:"/admin/bulkDeal/getDeal",

    downloadTransactions: "/admin/deal/downloadExcel",
    loadTrendRate: "/admin/fxTrend/loadTrend",
    updateTrendRate : "/admin/fxTrend/updateTrend",
    uploadCashFlow: "/admin/cashFlow/uploadCaseFlowData",
    getCashFlow: "/admin/cashFlow/list",
    getCashFlowCalenderData: "/admin/cashFlow/calenderData",
    getCashFlowWithUpdateRate: "/admin/cashFlow/listWithUpdate",
    addCashflowCover: "/admin/cashFlow/saveCover",
    deleteCashflow: "/admin/cashFlow/delete",

    getTransactionFromCashFlow: "/admin/deal/getCashDeal",
    getPendingCAshFlowForDeal: "/admin/deal/getPendingCashDeal",
    fxRefresh: "/admin/rate/startWebsocket",

    getCashFlowDet: "/admin/cashFlow/getData",
    saveCashFlowDet: "/admin/cashFlow/saveCashFlow",

    clientList: "/admin/user/getClientAll",
    getCashExposure: "/admin/cashFlow/getCashExposure",
    saveCashExposure: "/admin/cashFlow/saveCashExposure",

    getCoverDetForDeal: "/admin/cashFlow/getCoverDetForDeal",
    saveCoverDetForDeal: "/admin/cashFlow/saveCoverDeal",

    refreshMTMForDeal:"/admin/bulkDeal/refreshMTMForDeal",
    bulkFrdDealList:"/admin/bulkDeal/frdList",
    bulkMTMDealList:"/admin/bulkDeal/mtmList",
    bulkMTMDealListWithUpdate:"/admin/bulkDeal/mtmListWithUpdate",
    bulkMTMDownloadTransactions:"/admin/bulkDeal/downloadExcel",


    UploadBookedTransaction: "/admin/bookedTrans/uploadTransaction",


    getCurrencyMarginRequired: "/client/currencyMargin/add",
    editCurrencyMarginRequired: "/client/currencyMargin/edit",
    getCurrencyMarginDetails: "/client/currencyMargin/get",
    saveCurrencyMarginDetails: "/client/currencyMargin/save",
    deleteCurrencyMarginDetail: "/client/currencyMargin/delete",

  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
